// src/components/AddNoteModal.js
import React, { useState, useRef, useEffect } from 'react';
import { FiPaperclip, FiTrash2, FiFileText } from 'react-icons/fi';
import Modal from './Modal'; // ✅ Import Shared Component

const AddNoteModal = ({ isOpen, onClose, onSave }) => {
    const [noteText, setNoteText] = useState('');
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);

    // ... existing file handling logic (handleFileChange, removeFile) ...

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!noteText.trim() && files.length === 0) return;
        onSave({ text: noteText, files });
        setNoteText('');
        setFiles([]);
        onClose();
    };

    const handleCloseWrapper = () => {
        setNoteText('');
        setFiles([]);
        onClose();
    };

    const footerButtons = (
        <>
            <button type="button" className="btn btn-secondary" onClick={handleCloseWrapper}>
                Cancel
            </button>
            <button type="submit" form="add-note-form" className="btn btn-primary">
                Save Note
            </button>
        </>
    );

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleCloseWrapper}
            title="Add New Note"
            footer={footerButtons}
        >
            <form id="add-note-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="note-text">Note Details</label>
                    <textarea
                        id="note-text"
                        className="form-textarea"
                        rows="6"
                        value={noteText}
                        onChange={(e) => setNoteText(e.target.value)}
                        placeholder="Describe the update..."
                        autoFocus
                    />
                </div>
                {/* ... existing file upload UI ... */}
            </form>
        </Modal>
    );
};

export default AddNoteModal;